import { useQuery } from '@tanstack/react-query';
import { ACTIVE_CASES_KEY } from '../../utils/constants/queryKeys';
import { getActiveCases } from '../services/fn-api/Cases';
import { QueryParams } from '../types/Common';

export const useGetActiveCases = (params?: QueryParams) => {
  return useQuery({
    queryKey: [ACTIVE_CASES_KEY, params],
    queryFn: () => getActiveCases(params),
    retry: false,
  });
};
